import React from "react";
import store from "../app/store";
import { connect } from "react-redux";
import { createAction } from "@reduxjs/toolkit";
import { DangerToast } from "./DangerToast";
import { ACTION_TOAST_CHANGED } from "./ToastReducer";
import { debug } from "../utils";
import { SuccessToast } from "./SuccessToast";
import { InfoToast } from "./InfoToast";
import { WarningToast } from "./WarningToast";

export const TOAST_TYPES = {
    DANGER: "DangerToast",
    SUCCESS: "SuccessToast",
    INFO: "InfoToast",
    WARNING: "WarningToast"
}

function ToastContainer({ dispatch, message, type, title, subtitle }) {

    const onClose = (e) => {
        e.preventDefault()
        dispatch(createAction(ACTION_TOAST_CHANGED)(null));
    }

    const showToast = (type) => {
        switch (type) {
            case TOAST_TYPES.DANGER:
                return <DangerToast
                    message={message}
                    title={title}
                    subtitile={subtitle}
                    closeCallback={onClose}
                />;
            case TOAST_TYPES.SUCCESS:
                return <SuccessToast
                    message={message}
                    title={title}
                    subtitile={subtitle}
                />;
            case TOAST_TYPES.INFO:
                return <InfoToast
                    message={message}
                    title={title}
                    subtitile={subtitle}
                />;
            case TOAST_TYPES.WARNING:
                return <WarningToast
                    message={message}
                    title={title}
                    subtitile={subtitle}
                />;

            default:
                return null;
        }
    }

    if (!type) {
        return null;
    }

    return (
        <div id="toastsContainerTopRight" className="toasts-top-right fixed toast-container">
            {showToast(type)}
        </div>
    )
}


function mapStateToProps(state) {
    debug("ToastContainer mapStateToProps", state);
    return { ...state.toast }
}

export default connect(mapStateToProps)(ToastContainer);


export function showDangerToast(message, title, subtitle) {
    store.dispatch(createAction(ACTION_TOAST_CHANGED)({
        message: message,
        title: title,
        subtitle: subtitle,
        type: TOAST_TYPES.DANGER
    }));
}

export function showSuccessToast(message, title, subtitle, notHide) {
    store.dispatch(createAction(ACTION_TOAST_CHANGED)({
        message: message,
        title: title,
        subtitle: subtitle,
        notHide: notHide,
        type: TOAST_TYPES.SUCCESS
    }));

    if (!notHide) {
        setTimeout(() => {
            store.dispatch(createAction(ACTION_TOAST_CHANGED)(null));
        }, 3000)
    }
}

export function showInfoToast(message, title, subtitle, notHide) {
    store.dispatch(createAction(ACTION_TOAST_CHANGED)({
        message: message,
        title: title,
        subtitle: subtitle,
        notHide: notHide,
        type: TOAST_TYPES.INFO
    }));

    if (!notHide) {
        setTimeout(() => {
            store.dispatch(createAction(ACTION_TOAST_CHANGED)(null));
        }, 3000)
    }
}

export function showWarningToast(message, title, subtitle, notHide) {
    store.dispatch(createAction(ACTION_TOAST_CHANGED)({
        message: message,
        title: title,
        subtitle: subtitle,
        notHide: notHide,
        type: TOAST_TYPES.WARNING
    }));

    if (!notHide) {
        setTimeout(() => {
            store.dispatch(createAction(ACTION_TOAST_CHANGED)(null));
        }, 3000)
    }
}
